import { Component } from '@angular/core';
import { ArticleSourceRecord } from 'app/_models/common/article-source/article.source.record';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-article-source-response-dialog',
  templateUrl: './article-source-response-dialog.component.html',
  styleUrls: ['./article-source-response-dialog.component.scss']
})
export class ArticleSourceResponseDialogComponent {
  response: ArticleSourceRecord[];

  constructor(
    private bsModalRef: BsModalRef
  ) { }

  close(): void {
    this.bsModalRef.hide();
  }
}
